import React from 'react';
import PropTypes from 'prop-types';
import { RxCaretSort } from 'react-icons/rx';
import Checkbox from '../../Component/Checkbox/Checkbox';
import { IoMdCloseCircle } from 'react-icons/io';
import IconCollection from '../../IconCollection/IconCollection';

const TableHeader = (props) => {
  const {
    handleSortByRosterId,
    handleSortByJerseyNo,
    checkBoxOnChange,
    defaultValue,
    searchUserID,
    setSearchTerm,
    setSearchUserID,
    setCurrentSort,
    handleSortByUserId
  } = props;

  return (
    <div className="flex justify-center items-center w-[944px]">
      <div className="max-w-[110px] min-w-[110px] w-full h-[56px] bg-white border-l-0 border-r-0 border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-1 py-3">
        <button className="flex items-center gap-[2px] cursor-pointer" onClick={handleSortByRosterId}>
          Roster ID
          <RxCaretSort className='text-xl' />
        </button>
      </div>

      <button onClick={handleSortByJerseyNo} className="max-w-[120px] min-w-[120px] w-full h-[56px] bg-white border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-2 py-3">
        <div className="flex items-center gap-[2px] cursor-pointer">
          Jersey No
          <RxCaretSort className='text-xl' />
        </div>
      </button>
      <div className="max-w-[110px] min-w-[110px] w-full h-[56px] bg-white border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
        Playing
        <Checkbox
          svgClass={`max-w-6 w-full min-w-6 h-6`}
          mainClass={`max-w-[165px] w-full rounded h-10 gap-3 justify-center items-center px-[6px] py-2`}
          text={``}
          svgContainerClass={`flex justify-center items-center w-full`}
          textClass={`font-montserrat font-medium text-base flex-1 text-nowrap block`}
          onChange={checkBoxOnChange}
          defaultValue={defaultValue}
        />
      </div>

      <div className="max-w-[240px] min-w-[240px] w-full h-[56px] border-l-0 bg-white border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-between gap-3 items-center px-4 py-3">
        {searchUserID ? (
          <div className='flex items-center gap-2'>
            <input
              onChange={(event) => setSearchTerm(event.target.value)}
              type="text"
              className="bg-transparent outline-none w-full"
              placeholder="Search user"
            />
            <button
              onClick={() => {
                setSearchUserID(false);
                setSearchTerm(null);
              }}
              className="cursor-pointer">
              <IoMdCloseCircle />
            </button>
          </div>
        ) : (
          <>
            <button
              onClick={handleSortByUserId}
              className="flex items-center gap-[2px] cursor-pointer">
              User ID
              <RxCaretSort className='text-xl' />
            </button>
            <button
              onClick={() => {
                setSearchUserID(true);
                setCurrentSort("nome");
              }}
              className="cursor-pointer">
              <IconCollection name="search" />
            </button>
          </>
        )}
      </div>
      <div className="max-w-[132.94px] min-w-[132.94px] w-full h-[56px] bg-white border-l-0 border-r-0 border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
        Full Name
      </div>
      <div className="max-w-[132.94px] min-w-[132.94px] w-full h-[56px] bg-white border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
        Nickname
      </div>
      <div className="max-w-[80px] min-w-[80px] w-full h-[56px] bg-white border-[1px] border-[#E8E8E8] text-[#7D7D7D] font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
        Position
      </div>
    </div>
  );
};

TableHeader.propTypes = {
  handleSortByRosterId: PropTypes.func.isRequired,
  handleSortByJerseyNo: PropTypes.func.isRequired,
  checkBoxOnChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.bool.isRequired,
  searchUserID: PropTypes.bool.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  setSearchUserID: PropTypes.func.isRequired,
  setCurrentSort: PropTypes.func.isRequired,
  handleSortByUserId: PropTypes.func.isRequired,
};

export default TableHeader;